import { render, staticRenderFns } from "./Focus.vue?vue&type=template&id=16e13ffd&scoped=true&v-if=this.user.loggedIn"
import script from "./Focus.vue?vue&type=script&lang=js"
export * from "./Focus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e13ffd",
  null
  
)

export default component.exports